// App.js
import React, {useEffect, useState} from "react";
import AdvicesTable from "./CatalogComponent";
import {filterAdvices} from "../../Utils/annotator";
import {setAllAdvicesDB} from "../../Database/AdvicesDAO";

function AdvicesComponent(props) {
const [advices, setAdvices] = useState([]);
const [columns, setColumns] = useState([]);


    useEffect(async()=>{
        const columns = [
        {
          Header: 'Advice',
          accessor: 'advice'
        },
        {
          Header: 'Category',
          accessor: 'category'
        },
        {
          Header: 'Kommentor',
          accessor: 'kommentor'
        },
        {
          Header: 'AI-Tag',
          accessor: 'norm'
        },
            {
          Header: 'Formel',
          accessor: 'formel'
        },
            {
          Header: 'Anspruch',
          accessor: 'anspruch'
        },
            {
          Header: 'AdviceID',
          accessor: 'uidid'
        }
      ];
        setColumns(columns)
        let result = props.advicelist;

        setAllAdvicesDB(result)
        result = filterAdvices(result);

        setAdvices(result)
    },[])

        return (
            // eslint-disable-next-line react/react-in-jsx-scope
            <div className="px-10">
                <AdvicesTable lvid={props.lvid} data={advices} columns={columns} annotationData={props.annotationData}
                              setAnnotationData={props.setAnnotationData} handleClose={props.handleClose}/>
            </div>
        );
    }


export default AdvicesComponent;